// extracted by mini-css-extract-plugin
export default {"addressAction":"K5-z","loading":"L5-z"};